var _rect, _path, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcIllustrationFourCvv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    viewBox: "0 0 50 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3125,
    y: 0.3125,
    width: 49.375,
    height: 31.375,
    rx: 2.6875,
    fill: "#D9D9D9",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.504 11L8.448 5.664H7.024L4.96 11H6.208L6.544 10.08H8.928L9.264 11H10.504ZM8.616 9.096H6.848L7.736 6.648L8.616 9.096ZM17.1808 11V5.664H15.5808L14.2848 8.992L12.9888 5.664H11.3968V11H12.5328V7.16L14.0368 11H14.5328L16.0368 7.16V11H17.1808ZM22.4165 11V10.016H19.7765V8.776H22.3605V7.8H19.7765V6.64H22.4165V5.664H18.6405V11H22.4165ZM28.5446 11L26.6086 8.256L28.4246 5.664H27.0566L25.8486 7.488L24.6246 5.664H23.2726L25.0886 8.264L23.1526 11H24.5046L25.8486 9.048L27.1846 11H28.5446Z",
    fill: "#858585"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.875,
    y: 4.625,
    width: 13,
    height: 8.25,
    rx: 1.25,
    fill: "white",
    stroke: "#EE6666",
    strokeWidth: 1.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.47057,
    cy: 25.4706,
    r: 0.470573,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.17596,
    cy: 25.4706,
    r: 0.470573,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.8233,
    cy: 25.4706,
    r: 0.470573,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5297,
    cy: 25.4706,
    r: 0.470573,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2174,
    cy: 25.4674,
    r: 0.467415,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.8912,
    cy: 25.4674,
    r: 0.467415,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5543,
    cy: 25.4674,
    r: 0.467415,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.2289,
    cy: 25.4674,
    r: 0.467415,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8971,
    cy: 25.4674,
    r: 0.467415,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5709,
    cy: 25.4674,
    r: 0.467415,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.234,
    cy: 25.4674,
    r: 0.467415,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9086,
    cy: 25.4674,
    r: 0.467415,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.6461,
    cy: 25.4674,
    r: 0.467415,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.3199,
    cy: 25.4674,
    r: 0.467415,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.983,
    cy: 25.4674,
    r: 0.467415,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6576,
    cy: 25.4674,
    r: 0.467415,
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.125,
    cy: 8.625,
    r: 0.625,
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.625
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.625,
    cy: 8.625,
    r: 0.625,
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.625
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.625,
    cy: 8.625,
    r: 0.625,
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.625
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.125,
    cy: 8.625,
    r: 0.625,
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcIllustrationFourCvv);
export default __webpack_public_path__ + "static/media/cc-illustration-fourCVV.60d641909ee991f2624037f32fd05893.svg";
export { ForwardRef as ReactComponent };